import cx from "classnames";
import TextareaAutosize from "react-textarea-autosize";
import FieldWrapper from "../components/FieldWrapper";
import { InputFieldType } from "../types/feedbackFields.types";
import { FieldValueProps } from "./fields.types";
import { withSingleValue } from "./fields.utils";

// TODO: input mask
// <% if (field.inputMask) { %> data-inputmask="<%= field.inputMask %>"<% } %>

const InputField = ({ field, value, error, onChange }: { field: InputFieldType } & FieldValueProps<string>) => {
  const { inputType, _id, name, placeholder, required } = field;
  const id = _id || name;
  if (inputType === "textarea") {
    return (
      <FieldWrapper field={field} error={error}>
        <TextareaAutosize
          id={id}
          className={cx({ error })}
          placeholder={placeholder}
          name={id}
          rows={2}
          onChange={(e) => onChange(id, e.target.value)}
          value={value || ""}
          required={required}
        />
      </FieldWrapper>
    );
  }
  return (
    <FieldWrapper field={field} error={error}>
      <input
        id={id}
        className={cx({ error })}
        type={inputType || "text"}
        placeholder={placeholder}
        name={id}
        onChange={(e) => onChange(id, e.target.value)}
        value={value || ""}
        required={required}
      />
    </FieldWrapper>
  );
};
export default withSingleValue(InputField);
